import HomeIcon from "@/assets/ai-factory/home-check.png";
import NavTextIcon from "@/assets/ai-factory/nav-text.png";
import NavImageIcon from "@/assets/ai-factory/nav-image.png";
import NavVideo from "@/assets/ai-factory/nav-video.png";
import NavPublish from "@/assets/ai-factory/nav-fabu.png";
import NavRecord from "@/assets/ai-factory/nav-record.png";
import NavTemplate from "@/assets/ai-factory/nav-moban.png";
import NavRole from "@/assets/ai-factory/nav_role.png";
import NavProduct from "@/assets/ai-factory/nav_product.png";
import NavMarket from "@/assets/ai-factory/nav_market.png";
import NavLiveShow from "@/assets/ai-factory/nav_live_show.png";

import NavTemplateCheck from "@/assets/ai-factory/nav_template_check.png";
import NavRoleCheck from "@/assets/ai-factory/nav_role_check.png";
import NavProductCheck from "@/assets/ai-factory/nav_product_check.png";
import NavMarketCheck from "@/assets/ai-factory/nav_market_check.png";
import NavLiveShowCheck from "@/assets/ai-factory/nav_live_show_check.png";
import NavTextIconCheck from "@/assets/ai-factory/nav_text_check.png";
import NavImageIconCheck from "@/assets/ai-factory/nav_image_check.png";
import NavVideoCheck from "@/assets/ai-factory/nav_video_check.png";
import NavFabuCheck from "@/assets/ai-factory/nav_fabu_check.png";
import NavRecordCheck from "@/assets/ai-factory/nav_record_check.png";
import NavMatrix from "@/assets/ai-factory/matrix.png";
interface MenuItem {
  label?: string;
  path?: string;
  type: "path" | "click" | "line";
  icon?: string;
  checkIcon?: string;
  click?: () => void;
  children?: MenuItem[];
}
export const TopMenuItems: MenuItem[] = [
  {
    label: "首页",
    path: "/work-bench",
    type: "path",
    icon: HomeIcon,
    checkIcon: HomeIcon,
  },
];
export const MENU_ITEMS: MenuItem[] = [
  {
    label: "我的AI角色",
    path: "/my-ai-role",
    type: "path",
    icon: NavRole,
    checkIcon: NavRoleCheck,
  },
  {
    label: "营销定位与模板",
    path: "/marketing-position-template/topic",
    type: "path",
    icon: NavTemplate,
    checkIcon: NavTemplateCheck,
  },
  {
    type: "line",
  },
  {
    label: "AI文生视频",
    path: "/text-to-video",
    type: "path",
    icon: NavTextIcon,
    checkIcon: NavTextIconCheck,
  },
  {
    label: "AI图生视频",
    path: "/image-to-video",
    type: "path",
    icon: NavImageIcon,
    checkIcon: NavImageIconCheck,
  },
  {
    label: "AI口播视频",
    path: "/ai-live-show",
    type: "path",
    icon: NavLiveShow,
    checkIcon: NavLiveShowCheck,
  },
  {
    label: "AI营销视频",
    path: "/ai-market",
    type: "path",
    icon: NavMarket,
    checkIcon: NavMarketCheck,
  },
  {
    label: "AI产品视频",
    path: "/ai-product",
    type: "path",
    icon: NavProduct,
    checkIcon: NavProductCheck,
  },
  {
    type: "line",
  },
  {
    label: "我的AI视频集",
    path: "/my-video-collection",
    type: "path",
    icon: NavVideo,
    checkIcon: NavVideoCheck,
  },
  {
    label: "视频发布",
    path: "/video-publish",
    type: "path",
    icon: NavPublish,
    checkIcon: NavFabuCheck,
  },
  {
    type: "line",
  },
  {
    label: "算力消耗明细",
    path: "/consume-details",
    type: "path",
    icon: NavRecord,
    checkIcon: NavRecordCheck,
  },
  {
    label: "矩阵营销",
    path: "/matrix",
    type: "path",
    icon: NavMatrix,
    checkIcon: NavMatrix,
    children: [
      {
        label: "智能营销",
        path: "/matrix/1",
        type: "path",
        icon: NavMatrix,
        checkIcon: NavMatrix,
        click() {
          const token = localStorage.getItem("Token");
          window.open(`${process.env.REACT_APP_MATRIX}/login${token ? `?token=${token}` : ""}`, "_blank");
        },
      },
      {
        label: "客户端下载",
        path: "download",
        type: "path",
        icon: NavMatrix,
        checkIcon: NavMatrix,
      },
    ],
  },
];
